each decl in declarations 
    if decl.type == 'bitmap'
        | !{decl.data.name} = bytearray(!{decl.data.value})
        |
if settings.declare_vars
    each decl in declarations 
        if decl.type == 'var'
            if decl.data.type === 0
                | !{decl.data.name} = "!{decl.data.value}"
            else
                | !{decl.data.name} = !{decl.data.value}
            |
            |
|
|
- var pad = settings.wrap ? '    ' : ''
if settings.wrap
    | def draw():
    |
|
each layer in layers 
    if settings.comments
        | !{pad}// !{layer.name}
        |
    case layer.type
        when 'line'
            | @!{layer.uid};!{pad}display.line(@x1:!{layer.x1}, @y1:!{layer.y1}, @x2:!{layer.x2}, @y2:!{layer.y2}, !{layer.color})
        when 'rect'
            - var func = (layer.fill ? 'fill_rect' : 'rect')
            | @!{layer.uid};!{pad}display.!{func}(@x:!{layer.x}, @y:!{layer.y}, @w:!{layer.w}, @h:!{layer.h}, !{layer.color})
        when 'ellipse'
            - var isFill = layer.fill ? 'True' : 'False'
            | @!{layer.uid};!{pad}display.ellipse(@x:!{layer.x}, @y:!{layer.y}, @rx:!{layer.rx}, @ry:!{layer.ry}, !{layer.color}, !{isFill})
        when 'string'
            - var textContent = layer.isTextVariable ? layer.text : `"${layer.text}"`;
            | @!{layer.uid};!{pad}display.text(@text:!{textContent}, @x:!{layer.x}, @y:!{layer.y}, !{layer.color})
        when 'paint'
        when 'icon'
            | !{pad}fb_!{layer.imageName} = framebuf.FrameBuffer(!{layer.imageName}, !{layer.w}, !{layer.h}, framebuf.MONO_HLSB)
            | @!{layer.uid};!{pad}display.blit(fb_!{layer.imageName}, !{layer.x}, !{layer.y})
        default 
            |
            | // Unknown layer type !{layer.type}
            |
    |
    |
    |
| !{pad}display.show()
|